function toggleProductGrid(columns) {
    const productGrid = document.getElementById('st-collection-product-list');
    if (!productGrid) return;

    // Remove all grid classes
    productGrid.classList.remove(
        'collection__page-products-1',
        'collection__page-products-2',
        'collection__page-products-3',
        'collection__page-products-4',
        'collection__page-products'
    );

    // Add appropriate class
    if (columns === 4) {
        productGrid.classList.add('collection__page-products');
    } else {
        productGrid.classList.add(`collection__page-products-${columns}`);
    }

    // Update button UI states
    document.querySelectorAll('.searchtap-temp .st-product-grid-changer button').forEach(button => {
        const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
        const svgRects = button.querySelectorAll('svg rect');
        const svgPaths = button.querySelectorAll('svg path');

        if (buttonColumns === columns) {
            button.classList.add('active', '!st-bg-[#333]');
            button.classList.remove('st-bg-[#fff]');
            svgRects.forEach(rect => rect.setAttribute('fill', '#fff'));
            svgPaths.forEach(path => path.setAttribute('fill', '#fff'));
        } else {
            button.classList.remove('active', '!st-bg-[#333]');
            button.classList.add('st-bg-[#fff]');
            svgRects.forEach(rect => rect.setAttribute('fill', '#333'));
            svgPaths.forEach(path => path.setAttribute('fill', '#333'));
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('st-collection-product-list');
    const gridButtons = document.querySelectorAll('.st-product-grid-changer button');

    // Default to 4 columns on desktop, 1 column on mobile
    const initialColumns = window.innerWidth <= 768 ? 2 : 4;
    toggleProductGrid(initialColumns);
});



 document.addEventListener('DOMContentLoaded', function () {
    const target = document.querySelector('#product-grid-Pagination');
  if (target) {
    window.observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (document.querySelector('#product-grid-Pagination .btn'))
            document.querySelector('#product-grid-Pagination .btn').click();
        }
      });
    });

    window.observer1.observe(target);
    window.onClickCollectionPagination = async (link, event) => {
      event.preventDefault();
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
         
      <div class="st-results-loader">
      <div class="result-loading" style="text-align: center">
      </div>
      </div>

    `;

      const respoonse = await fetch(link.getAttribute('href'));
      const data = await respoonse.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');

      document
        .querySelector('#collectionmodalcontainer .st-collection-product-list-wrapper')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('#collectionmodalcontainer .st-collection-product-list-wrapper').innerHTML);

      document
        .querySelector('#product-grid-Pagination')
        .replaceWith(newDocument.querySelector('#product-grid-Pagination'));

      window.observer1.observe(document.querySelector('#product-grid-Pagination'));


      const customEvent2 = new CustomEvent('st.collection.paginated');
      window.dispatchEvent(customEvent2);

        setTimeout(function() {
  let images = document.querySelectorAll('img[loading="lazy"]:not([data-bstr-initd])');

  for (let i = 0, maxi = images.length; i < maxi; ++i) {
    let t = images[i];
    if (t.dataset.sizes) t.sizes = t.dataset.sizes;
    if (t.dataset.src) t.src = t.dataset.src;
    if (t.dataset.srcset) t.srcset = t.dataset.srcset;
    t.dataset.bstrInitd = "true";
  }
}, 100);
    };
  }
  });


document.addEventListener('DOMContentLoaded', () => {
  const goToTopButton = document.getElementById('goToTopButton');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      goToTopButton.style.display = 'flex';
    } else {
      goToTopButton.style.display = 'none';
    }
  });

goToTopButton.addEventListener('click', () => {
  let scrollToPosition = document.querySelector('.bannerImage-with-text-overlay') ? 250 : 0;
  window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
});

});





document.addEventListener('DOMContentLoaded', () => {
  function getLocalizationFromCookies() {
    const cookies = document.cookie.split(';').map(c => c.trim());
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === 'localization') return value;
    }
    return null;
  }

  const userLocation = getLocalizationFromCookies();

  if (userLocation && userLocation.toUpperCase() === 'US') {
    const productList = document.getElementById('st-collection-product-list');
    const spinner = document.querySelector('.ajaxinate-spinner') || document.querySelector('.infinite-scroll__loader');
    const pagination = document.getElementById('product-grid-Pagination');

    function removeBlockedProducts(container) {
      const holders = container.querySelectorAll('.card--holder');
      holders.forEach(el => {
        const tags = (el.getAttribute('data-tags') || '').toLowerCase();
        if (tags.includes('us_block')) {
          el.remove();
        }
      });
    }

    function checkAndEndScroll() {
      const visibleProducts = productList.querySelectorAll('.card--holder');

      if (!visibleProducts.length) {
        if (typeof Ajaxinate !== 'undefined') {
          Ajaxinate.destroy();
        }

        if (spinner) {
          spinner.style.display = 'none';
        }

        if (pagination) {
          pagination.style.display = 'none';
        }

        const parent = document.querySelector('#collectionmodalcontainer');
        if (parent) {
          const wraps = parent.querySelectorAll('.st-filter-count-sort-wrap');
          wraps.forEach(wrap => {
            wrap.style.setProperty('display', 'none', 'important');
          });
               parent.classList.add('us_no_result');
        }

        productList.innerHTML = '<div class="st-no-more-products">No matching products for your region.</div>';
      }
    }

    removeBlockedProducts(document);
    checkAndEndScroll();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const cards = node.matches('.card--holder')
              ? [node]
              : node.querySelectorAll?.('.card--holder') || [];

            cards.forEach(card => {
              const tags = (card.getAttribute('data-tags') || '').toLowerCase();
              if (tags.includes('us_block')) {
                card.remove();
              }
            });

            checkAndEndScroll();
          }
        });
      });
    });

    observer.observe(productList, { childList: true, subtree: true });
  }
});







